import * as React from 'react'
import {ErrorInfo, ReactNode} from 'react'

interface ErrorBoundaryState {
    hasError: boolean
}
interface Props {
    children: ReactNode
}
export class ErrorBoundary extends React.Component<Props, ErrorBoundaryState> {
    state: ErrorBoundaryState = {hasError: false}

    static displayName: string = 'ErrorBoundary'

    componentDidCatch(error: Error, info: ErrorInfo): void {
        this.setState({hasError: true})
    }

    render(): ReactNode {
        if (this.state.hasError) {
            return <div>致命的なエラー</div>
        }
        return <>{this.props.children}</>
    }
}
